import {
  IDashboardDataResponse,
  INextGenDashboardRequest,
  INextGenDashboardResponse,
} from '../contracts/Dashboard';
import { IZeosApiResponse } from '../contracts/ZeosApi';
import { getDataAsync, postDataAsync } from '../ZeosApiExecutor';
import { IDashboard } from './interfaces/IDashboard';

const BASE_URL = `/Dashboard`;

const withDateQuery = (path: string, startDate?: string, endDate?: string) => {
  if (!startDate || !endDate) {
    return path;
  }
  const params = new URLSearchParams({
    startDate,
    endDate,
  });
  return `${path}?${params.toString()}`;
};

export const Dashboard: IDashboard = {
  getDashboardData: async (
    propertyId: number,
    startDate?: string,
    endDate?: string
  ): Promise<IZeosApiResponse<IDashboardDataResponse>> => {
    return await getDataAsync<IDashboardDataResponse>(
      withDateQuery(`${BASE_URL}/Data/${propertyId}`, startDate, endDate),
      "data"
    );
  },
  getNextGenDashboard: async (
    request: INextGenDashboardRequest
  ): Promise<IZeosApiResponse<INextGenDashboardResponse>> => {
    return await postDataAsync<INextGenDashboardResponse>(
      `${BASE_URL}/NextGen`,
      request
    );
  },
};
